module.exports = __webpack_public_path__ + "img/placeholder6-opti.848fae65.png";